// extracted by css-extract-rspack-plugin
export default {"indexCard":"DynamicIndexTemplate-module__indexCard__aFY8wIY"};